// 1) util de clone profond (prend en charge + rapide si structuredClone dispo)
const deepClone = (v) =>
    typeof structuredClone === "function" ? structuredClone(v) : JSON.parse(JSON.stringify(v));

// 2) helpers numériques et maps d’agrégats (identiques à avant)
const num = v => Number.isFinite(v) ? v : Number(v || 0);
const ROOT_NUMS  = ["totalTurnover","totalTurnoverWithSeats","nbSeats","totalOrders","orderCount","totalDuration","offeredCount","totalDiscount"];
const STAFF_NUMS = [...ROOT_NUMS, "totalWorkMinutes"];
const LOC_NUMS   = ROOT_NUMS;
const SLOT_NUMS  = ["totalTurnover","totalTurnoverWithSeats","nbSeats","totalOrders","totalDuration","offeredCount","totalDiscount"];
const AVERAGES = new Set(["averageTicket","averageSeatTicket","averageSeatTurnover","averageDuration"]);

const addNumerics = (target, source, keys) => {
    // crée un NOUVEL objet avec les additions (immutabilité)
    const out = { ...target };
    for (const k of keys) out[k] = num(target?.[k]) + num(source?.[k]);
    return out;
};

const mergeTotalsMap = (dst={}, src={}) => {
    // renvoie un NOUVEL objet
    const out = { ...dst };
    for (const [id, v] of Object.entries(src)) {
        const cur = out[id]?.totalPrice || 0;
        out[id] = { totalPrice: num(cur) + num(v.totalPrice) };
    }
    return out;
};

const mergeOptions = (dst={}, src={}) => {
    const out = { ...dst };
    for (const [optId, o2] of Object.entries(src)) {
        const cur = out[optId] || { quantity: 0, totalPrice: 0 };
        out[optId] = {
            quantity:   num(cur.quantity)   + num(o2.quantity),
            totalPrice: num(cur.totalPrice) + num(o2.totalPrice),
        };
    }
    return out;
};

// 3) merge principal IMMUTABLE
export function mergeSumUpDayData(data1, data2) {
    if (!data1) return deepClone(data2);
    if (!data2) return deepClone(data1);

    // point d’entrée : cloner data1 une seule fois
    let merged = deepClone(data1);

    // Racine
    merged = addNumerics(merged, data2, ROOT_NUMS);
    merged.byPaymentType = mergeTotalsMap(merged.byPaymentType, data2.byPaymentType);

    // detailbyStaff
    const outStaffs = { ...(merged.detailbyStaff || {}) };
    for (const [staffId, s2] of Object.entries(data2.detailbyStaff || {})) {
        const sM0 = outStaffs[staffId];
        if (!sM0) {
            // copier tel quel depuis data2 → CLONE pour ne pas référencer data2
            outStaffs[staffId] = deepClone(s2);
            continue;
        }

        // staff
        let sM = addNumerics(sM0, s2, STAFF_NUMS);
        sM.payments = mergeTotalsMap(sM.payments, s2.payments);

        // locations
        const locsOut = { ...(sM.locations || {}) };
        for (const [locId, l2] of Object.entries(s2.locations || {})) {
            const lM0 = locsOut[locId];
            if (!lM0) {
                locsOut[locId] = deepClone(l2);
                continue;
            }

            let lM = addNumerics(lM0, l2, LOC_NUMS);

            // products.timeSlot
            const tsOut = { ...((lM.products && lM.products.timeSlot) || {}) };
            for (const [slotKey, slot2] of Object.entries(l2.products?.timeSlot || {})) {
                const slotM0 = tsOut[slotKey];
                if (!slotM0) {
                    tsOut[slotKey] = deepClone(slot2);
                    continue;
                }

                // agrégats du slot
                let slotM = addNumerics(slotM0, slot2, SLOT_NUMS);

                // produits du slot
                const prodOut = { ...slotM };
                for (const [k, v2] of Object.entries(slot2)) {
                    if (SLOT_NUMS.includes(k) || AVERAGES.has(k)) continue;
                    if (typeof v2 !== "object" || v2 === null) continue;
                    if (typeof v2.quantity !== "number" || typeof v2.totalPrice !== "number") continue;

                    const p0 = prodOut[k] || { quantity: 0, totalPrice: 0, options: {} };
                    prodOut[k] = {
                        quantity:   num(p0.quantity)   + num(v2.quantity),
                        totalPrice: num(p0.totalPrice) + num(v2.totalPrice),
                        options:    mergeOptions(p0.options, v2.options),
                    };
                }
                tsOut[slotKey] = prodOut;
            }

            lM = {
                ...lM,
                products: { ...(lM.products || {}), timeSlot: tsOut },
                // (si tu merges aussi lM.payments.timeSlot, fais-le ici en immuable)
            };

            locsOut[locId] = lM;
        }

        sM = { ...sM, locations: locsOut };
        outStaffs[staffId] = sM;
    }

    merged.detailbyStaff = outStaffs;

    // ⚠️ Recalcule ensuite les moyennes (average*) à l’affichage, pas ici.

    return merged;
}
